import { apiSlice } from '../../api/apiSlice';

export const assignmentDocumentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeacherDocuments: builder.mutation({
      query: () => ({
        url: 'AssignmentDocument/TeacherDocuments',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getPublicDocuments: builder.mutation({
      query: () => ({
        url: 'AssignmentDocument/PublicDocuments',
        method: 'GET',
        credentials: 'include'
      })
    }),
    addDocuments: builder.mutation({
      query: (option) => ({
        url: `AssignmentDocument/${option.documentId}/Assignment/${option.assignmentId}?label=${option.label}`,
        method: 'POST',
        credentials: 'include'
      })
    }),
  })
});

export const {
  useGetTeacherDocumentsMutation,
  useGetPublicDocumentsMutation,
  useAddDocumentsMutation,
} = assignmentDocumentApi;